export default function TransactionIcon() {
  return (
    <>
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="36" height="36" rx="4" fill="#F0F3F9" />
        <path
          d="M21.7495 21.75H24.7495M17.2495 21.75H18.7495M8.24951 15.0799H27.7495M9.00006 11.25H27.0001C27.4143 11.25 27.7501 11.5858 27.7501 12V24C27.7501 24.4142 27.4143 24.75 27.0001 24.75H9.00006C8.58585 24.75 8.25006 24.4142 8.25006 24V12C8.25006 11.5858 8.58585 11.25 9.00006 11.25Z"
          stroke="#2D3643"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
